export const encode = value => {
  const { accessToken, refreshToken, refreshTokenExpiresAt, user } = value;
  const token = JSON.stringify({
    user,
    accessToken,
    refreshToken,
    refreshTokenExpiresAt,
  });
  return btoa(token);
};

export const decode = token => {
  if (!token) return undefined;
  return JSON.parse(atob(token));
};
